/**
 * KAN-887: выпадающий список "Сортировка" таблицы CRM (варианты и правила в
 * lib/crmTableSort, состояние в useCrmTablePeriod). Компонент только рисует.
 * KAN-906: в закрытом поле подпись "Сортировка: по дате взятия", пункты списка как есть.
 */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CRM_SORT_OPTIONS } from '@/lib/crmTableSort';
import type { CrmTableSort } from '@/types/crm';

interface CrmTableSortSelectProps {
  value: CrmTableSort;
  onChange: (value: CrmTableSort) => void;
}

export function CrmTableSortSelect({ value, onChange }: CrmTableSortSelectProps): JSX.Element {
  const current = CRM_SORT_OPTIONS.find((o) => o.value === value);
  const shown = current ? current.label.charAt(0).toLowerCase() + current.label.slice(1) : '';
  const select = (next: string) => {
    const option = CRM_SORT_OPTIONS.find((o) => o.value === next);
    if (option) onChange(option.value);
  };
  return (
    <Select value={value} onValueChange={select}>
      <SelectTrigger data-testid="crm-sort" aria-label="Сортировка" className="h-8 w-auto min-w-[10rem] text-sm">
        <SelectValue className="whitespace-nowrap">Сортировка: {shown}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {CRM_SORT_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
